import { AUTH_LOGOUT } from '@/store/actions';
import { useAuthStore } from '@/stores/auth';
import { pinia } from '@/stores/pinia';

export default {
	response: {
		name: 'Handle invalidated user session',
		config: (response) => {
			return response;
		},
		error: async (error) => {
			if (error.response?.status === 401) {
				const responseData = error.response.data;
				if (responseData?.code === 1400) {
					const authStore = useAuthStore(pinia);
					await authStore[AUTH_LOGOUT]();
					window.location.assign('/login');
				}
			}
			return Promise.reject(error);
		},
	},
};
